import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { TableContainer } from 'components/DefaultTable/styles';

import colors from 'themes/Main';

const { white, darkBlue, gray03 } = colors;

export const Table = styled(TableContainer)`
  tbody tr td:nth-child(2) {
    width: 20vw;
  }

  tbody tr td:nth-child(3) {
    width: 14vw;
  }

  thead tr th:last-child {
    text-align: center;
  }

  tbody tr td:last-child {
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    button {
      background: transparent;
      border: 0;
      outline: 0;

      &:hover > svg path {
        fill: ${darkBlue};
      }
    }
  }

  thead tr th:nth-child(1),
  tbody tr td:nth-child(1),
  thead tr th:nth-child(4),
  tbody tr td:nth-child(4) {
    text-align: center;
  }

  tbody tr {
    cursor: default;

    &:hover {
      background-color: ${white};
    }
  }
`;

export const EditEmployee = styled(Link)`
  display: block;
  margin-right: 16px !important;

  &:hover > svg path {
    fill: ${darkBlue};
  }
`;

export const Callback = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 64px;
`;

export const CallbackText = styled.h2`
  width: 500px;
  margin-top: 32px;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  color: ${gray03};
  text-align: center;

  p {
    display: block;
    margin-bottom: 8px;
  }
`;
